import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { CommentWithAction } from './comment-with-action';
import { CommentsService } from '@frontend-site/comments/domain';

@Component({
    selector: 'p-field-comment-with-action',
    templateUrl: 'p-field-comment-with-action.html',
    styleUrls: ['p-field-comment-with-action.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldCommentWithActionComponent
        }
    ]
})
export class PFieldCommentWithActionComponent extends PFieldAbstractComponent<CommentWithAction> implements AfterViewInit {
    @Input() protected label: string = '';
    @Input() protected actionText: string = '';

    @Input()
    set commentWithAction(value: CommentWithAction | undefined) {
        this.value = value;
        if (value && value.text) {
            this.commentContent = this.commentsService.processComment(value.text);
        }
    }

    get commentWithAction(): CommentWithAction | undefined {
        return this.value;
    }

    @Output() protected actionClick = new EventEmitter();
    @ViewChild('commentField')
    readonly commentField!: ElementRef<HTMLDivElement>;

    constructor(protected override cd: ChangeDetectorRef, private commentsService: CommentsService) {
        super(cd);
    }

    isExpanded: boolean = false;
    isTextOverflows: boolean = false;
    commentClass: string = 'short-comment';
    prefixesToRemove = ['about ', 'less than ', 'almost ', 'over ', 'more than '];
    commentContent: { type: string; value: string }[] = [];

    ngAfterViewInit(): void {
        this.updateTextOverflowsStatus();
    }

    updateTextOverflowsStatus(): void {
        if (this.commentField && this.value?.text) {
            const isOverflowing = this.isTextOverflowing(this.commentField.nativeElement);
            if (this.isTextOverflows !== isOverflowing) {
                this.isTextOverflows = isOverflowing;
                this.cd.detectChanges();
            }
        }
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollHeight > element.clientHeight;
    }

    expandElement(): void {
        this.isExpanded = !this.isExpanded;
        this.updateCommentClass();
        this.updateTextOverflowsStatus();
    }

    updateCommentClass(): void {
        this.commentClass = this.isExpanded ? 'long-comment' : 'short-comment';
        this.cd.detectChanges();
    }

    openInNewTab(): void {
        window.open(this.value?.fullTextLink);
    }

    removePrefix(value: string): string {
        const pattern = new RegExp(`^(${this.prefixesToRemove.join('|')})`);
        return value.replace(pattern, '').trim();
    }
}
